(function() {
  function applyNikeHover() {
    var items = document.querySelectorAll(
      '.header__inline-menu .list-menu--inline > li > a.header__menu-item, ' +
      '.header__inline-menu .list-menu--inline > li > details > summary.header__menu-item'
    );

    items.forEach(function(item) {
      // Evitar duplicar
      if (item.querySelector('.aware-nav-underline')) return;

      // Criar a linha
      var line = document.createElement('span');
      line.className = 'aware-nav-underline';
      line.style.cssText = [
        'position:absolute',
        'bottom:10px',
        'left:50%',
        'transform:translateX(-50%)',
        'width:0',
        'height:1.5px',
        'background:currentColor',
        'display:block',
        'pointer-events:none',
        'transition:width 0.3s cubic-bezier(0.25,0.46,0.45,0.94)'
      ].join(';');
      item.appendChild(line);

      // Hover in
      item.addEventListener('mouseenter', function() {
        var w = item.offsetWidth - 28; // 2 * 0.9rem padding (~14px each)
        line.style.width = Math.max(w, 0) + 'px';
      });

      // Hover out
      item.addEventListener('mouseleave', function() {
        line.style.width = '0';
      });
    });
  }

  // Executar quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyNikeHover);
  } else {
    applyNikeHover();
  }

  // Re-executar se o Shopify recarregar a secção no editor
  document.addEventListener('shopify:section:load', function() {
    setTimeout(applyNikeHover, 100);
  });
})();
